import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_aozh3p8j9i: FaireBrandEntity = {
  token: "b_aozh3p8j9i",
  type: "brand",
  name: "Original Sprout",
  avatarUrl:
    "https://cdn.faire.com/fastly/e8c679393aefaee3e9fff6e55a29406379d6471ba2ee57b944ca1cfa3870fc39.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/29fe8194585d46d280aee1b400522e4a2e2fda5531c7e185040eb0c607c9c187.png",
  logoUrl:
    "https://cdn.faire.com/fastly/e8c679393aefaee3e9fff6e55a29406379d6471ba2ee57b944ca1cfa3870fc39.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/29fe8194585d46d280aee1b400522e4a2e2fda5531c7e185040eb0c607c9c187.png",
  location: "San Clemente, CA, USA",
  minimumOrderDollars: 50,
  rating: 4.8,
  reviewCount: 27,
  isTopShop: true,
  isInsider: true,
  description:
    "Original Sprout makes safe and effective products that parents can count on. Original Sprout was founded in 2003 as a true labor of love by a top hairstylist in Santa Barbara, when she was a new mom. She sought to make products with ingredients that were safe to use on the sensitive skin of her daughter, and that other mothers and fathers could trust. Inspired by the needs of many parents who were asking her for detangling and styling advice, a full line of products was slowly developed.  Original Sprout has grown into a complete collection of soothing shampoos, conditioners, styling and body care products for the entire family, all produced and packaged in California, USA. Formulated without any irritants such as parabens and phthalates, Original Sprout also does not include ingredients such as lavender and tea-tree oil, which have been linked to hormone disruption in children.  Our vegan and cruelty-free products are each individually tested as non-toxic, safe, and effective. Our proprietary formulas contain nourishing extracts from fruits, vegetables and flowers, the whole family can enjoy. We're not just for babies anymore! ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:18.585Z",
    importedBy: "entity-db-cli",
  },
};
